import type { TPageNumberingFrontMatterOption } from '@/types/print-books'

export const pageNumberingFrontMatterOptions: TPageNumberingFrontMatterOption[] = [
  { name: 'lower-roman', label: 'i, ii, iii' },
  { name: 'upper-roman', label: 'I, II, III' },
  { name: 'none', label: 'None' },
]
